import * as S from "./styled";
import { useForm, SubmitHandler } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
//Components
import LayoutWithList from "../../../LayoutModal/WithList";
import ActionButton from "../../../Button/ActionButton";
import Delete from "../../Delete";
import Update from "../Update";
import Loading from "../../../../components/Loading";
//hooks
import apiRequest from "../../../../hooks/apiRequest";
import { useMultipleModal } from "../../../../hooks/useMultipleModal";
import { useEffect, useState } from "react";
import useLoading from "../../../../hooks/useLoading";
//Icons
import { PencilSimple, Trash } from "@phosphor-icons/react";
//Interfaces
import { Inputs, ISurfacing } from "Interfaces/ISurfacing";
import { ICreate } from "Interfaces/IModalCreate";

export default function CreateSurfacing({
  isOpenModal,
  setModalClose,
  refreshFrames,
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    reset,
    formState: { errors },
  } = useForm<Inputs>();

  const {
    isOpenModal: useIsOpenModals,
    toggleModalVisibility
  } = useMultipleModal();

  const isUpdateModalOpen = useIsOpenModals("update");
  const isDeleteModalOpen = useIsOpenModals("delete");
  const { isLoading, startLoading, stopLoading } = useLoading();

  const tableHead = ["#", "Nome", "Ações"];
  const [data, setData] = useState<ISurfacing[]>([]);
  const [openModalOptId, setOpenModalOptId] = useState<number | null>(null);

  const clickPopTable = (id: number, acao: string) => {
    setOpenModalOptId(id);
    toggleModalVisibility(acao);
  };

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(`surfacing`);
      setData(response.data);
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModal) {
      fetchData();
    }
  }, [isOpenModal]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {
      const response = await apiRequest("surfacing", "POST", data);
      if (response.status === 201) {
        alert("Surfaçagem criada com sucesso!");
        fetchData();
        refreshFrames();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar a surfaçagem.");
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
  };

  if (isOpenModal) {
    return (
      <LayoutWithList
        title="Registrar Surfaçagem"
        subTitle="Cadastre uma nova  surfaçagem em sua base de dados."
        setModalClose={onClose}
      >
        <S.Container>
          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>
                Nome da surfaçagem
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe a sufaçagem"
                type="text"
                {...register("surfacing", { required: true })}
              />
              {errors.surfacing && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>

            <S.ContentButton>
              <ActionButton
                name="Salvar"
                onClick={handleFormSubmit(onSubmit)}
              />
            </S.ContentButton>
          </S.SeparateDiv>
        </S.Container>

        <S.Footer>
          <S.TitleList>Tipos Cadastrados</S.TitleList>
          {isLoading ? (
            <Loading />
          ) : (

            <S.Table>
              <thead>
                <tr>
                  {tableHead.map((val) => {
                    return <th>{val}</th>;
                  })}
                </tr>
              </thead>
              <tbody>
                {data.map((val, index) => {
                  return (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{val.surfacing || "-"}</td>
                      <td>
                        <S.ContentButton>
                          <S.ButtonIconTable
                            onClick={() => clickPopTable(val.id, "update")}
                          >
                            <PencilSimple size={20} />
                          </S.ButtonIconTable>

                          <S.ButtonIconTable
                            onClick={() => clickPopTable(val.id, "delete")}
                          >
                            <Trash size={20} color="red" />
                          </S.ButtonIconTable>
                        </S.ContentButton>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </S.Table>
          )}
        </S.Footer>

        <Update
          isOpenModalUpdate={isUpdateModalOpen}
          setModalClose={() => toggleModalVisibility("update")}
          selectedUrlId={openModalOptId}
          updateList={fetchData}
        />

        <Delete
          updateList={fetchData}
          endpoint="surfacing"
          selectedProductId={openModalOptId}
          isOpenModal={isDeleteModalOpen}
          setModalClose={() => toggleModalVisibility("delete")}
        />
      </LayoutWithList>
    );
  }
  return null;
}
